module.exports = __webpack_public_path__ + "static/media/si-handaxe.f2dc2b44.png";